import * as analytics from 'analytics/Analytics';
import {AnalyticsEventMetadata} from 'analytics/AnalyticsTypes';
import {BULK_ACTION_ON_SEARCH_RESULTS} from 'constants/analytics-products/SearchAnalyticsConstants';
import {ACTION_CATEGORY, SEARCH_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {SearchResults} from 'search/SearchConstants';

export function trackSelectedSearchResult(itemId: string, searchResults?: SearchResults | null): void {
  if (searchResults) {
    const position = searchResults.ids.findIndex((id) => id === itemId) + 1;
    trackSelectedItem(itemId, position, searchResults.correlationId);
  }
}

export function trackSelectedItem(itemId: string, position: number, correlationId?: string | null): void {
  if (correlationId) {
    analytics.deprecatedTrackEvent(SEARCH_ANALYTICS_ACTIONS.CLICKED_SEARCH_RESULT, {
      searchCorrelationId: correlationId,
      itemId,
      position,
    });
  }
}

export enum BulkActionContext {
  BLAST = 'BLAST',
}

export function trackBulkActionOnSearchResults(
  actionName: string,
  itemIndices: Array<number>,
  actionCategory: ACTION_CATEGORY,
  bulkActionContext?: BulkActionContext
): void {
  const metadata: AnalyticsEventMetadata = {
    actionName,
    positions: itemIndices.map((i) => i + 1),
    itemCount: itemIndices.length,
  };
  if (bulkActionContext != null) {
    metadata.context = bulkActionContext;
  }
  analytics.trackEvent(BULK_ACTION_ON_SEARCH_RESULTS[actionCategory], metadata);
}
